import { render, staticRenderFns } from "./w-select.vue?vue&type=template&id=1691614b&lang=pug&"
import script from "./w-select.vue?vue&type=script&lang=js&"
export * from "./w-select.vue?vue&type=script&lang=js&"
import style0 from "./w-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1691614b')) {
      api.createRecord('1691614b', component.options)
    } else {
      api.reload('1691614b', component.options)
    }
    module.hot.accept("./w-select.vue?vue&type=template&id=1691614b&lang=pug&", function () {
      api.rerender('1691614b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-select.vue"
export default component.exports